/* eslint-disable */
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import styles from "./AdditionalLabelMarker.module.css"
import { updateGhostBeat, updateMouse, updateContext } from "../../pages/Annotator/AnnotatorSlice"
import { ADDITIONAL_LABEL_ARROW_PATH, ADDITIONAL_LABEL_ARROW_HEIGHT } from "../../constants/annotator"

// A non-beat positional marker (p-wave peak, pace spike). Rendered as a
// downward arrow whose tip touches the annotated point: it reads as distinct
// from the round beat markings while keeping the waveform itself unobscured.
// Shows the label name in a tooltip above the point on hover — matching Beat.jsx.
const AdditionalLabelMarker = (props) => {
    const {
        coordinates = [0, 0],
        x = coordinates[0],
        y = coordinates[1],
        name,
        color,
        field,
        index,
        ghost = false,
    } = props

    const dispatch = useDispatch()
    const [hovered, setHovered] = useState(false)

    // Right-click (or Ctrl-click) opens the reclassify menu immediately. Plain
    // left-click only arms drag state; the menu opens on mouseup if the marker
    // was never actually dragged, so it stays hidden while repositioning.
    const clicked = (e) => {
        e.preventDefault()
        e.stopPropagation()
        const isMenuIntent = e.button === 2 || e.ctrlKey
        dispatch(updateGhostBeat({ show: false }))
        if (!isMenuIntent) {
            dispatch(updateMouse({
                mousedown: true,
                mouseDownOnBeat: false,
                mouseDownOnAdditionalField: field,
                bStart: index,
                iStart: index,
                dragging: false,
            }))
            return
        }
        dispatch(updateContext({
            show: true,
            data: {
                top: y,
                left: x,
                showDelete: true,
                beatIndex: index,
                additionalField: field,
            },
        }))
    }

    // The drag preview must not swallow pointer events, or the mousemove/mouseup
    // that complete the drag never reach the container handler.
    if (ghost) {
        return (
            <svg className={styles.marker}>
                <g transform={`translate(${x},${y})`} pointerEvents="none">
                    <path d={ADDITIONAL_LABEL_ARROW_PATH} fill={color} fillOpacity="0.5" />
                </g>
            </svg>
        )
    }

    return (
        <svg className={styles.marker}>
            <g transform={`translate(${x},${y})`}>
                <path d={ADDITIONAL_LABEL_ARROW_PATH} fill={color} pointerEvents="none" />
                {/* The arrow shaft is only a couple of pixels wide, so clicks and
                    drags are picked up by an invisible strip over the whole glyph. */}
                <rect
                    x="-6"
                    y={-ADDITIONAL_LABEL_ARROW_HEIGHT}
                    width="12"
                    height={ADDITIONAL_LABEL_ARROW_HEIGHT}
                    fill="transparent"
                    onMouseDown={clicked}
                    onContextMenu={clicked}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                />
                {hovered && (
                    <g pointerEvents="none" transform={`translate(0,${-ADDITIONAL_LABEL_ARROW_HEIGHT - 2})`}>
                        <rect x="-45" y="-16" width="90" height="18" rx="3" ry="3" fill="rgba(0,0,0,0.8)" />
                        <text x="0" y="-3" textAnchor="middle" fill="#fff" fontSize="12" fontFamily="sans-serif">{name}</text>
                    </g>
                )}
            </g>
        </svg>
    )
}

export default AdditionalLabelMarker
